module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("新增发票寄送地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefaultString),
      expression: "expressInfo.isDefaultString"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefaultString) ? _vm._i(_vm.expressInfo.isDefaultString, null) > -1 : (_vm.expressInfo.isDefaultString)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefaultString,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefaultString", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefaultString", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eaf556d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyInvoice/AddInvoiceAddress.vue
// module id = 1629
// module chunks = 8